import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import b from 'b_';

import './home.css';

import Homepage from '@interfaces/homepage';
import Banner from '@components/banner';
import Themes from '@components/themes-widget';
import News from '@components/news-widget';
import EntitiesBlock from '@components/entities-block';
import { Publication } from '@interfaces/publications-page';
import PublicationItem from 'client/components/publication-item';
import ResearcherBlock from '@components/researcher/researcher';
import { Researcher } from '@interfaces/researchers-page';
import ResearchersHomeBlock from '@components/researchers-home-block';
import PageMeta from '@components/page-meta';

import pageConfig from './page-config.json';
import HomePageStub from './home.stub';

export interface DispatchProps {
    fetchHomepage(): void;
}

export interface SizeProps {
    isDesktop: boolean;
}

export interface StateProps {
    data: Homepage;
    isLoading: boolean;
}

type Props = SizeProps & StateProps & DispatchProps;

const class_ = b.with('home-page');
const blockClass_ = b.with('block');
const { bannerData, researchersDescription } = pageConfig;

export default class HomePage extends Component<Props> {
    public componentDidMount() {
        if (!this.props.data.researchers.length) {
            this.props.fetchHomepage();
        }
    }

    public shouldComponentUpdate() {
        return true;
    }

    public renderBlockHead(title: string, link?: { url: string; text: string }) {
        return (
            <div className={blockClass_('head')}>
                <div className={blockClass_('title')}>
                    {title}
                </div>
                {link && (
                    <Link to={link.url} className={blockClass_('title-link')}>
                        {link.text}
                    </Link>
                )}
            </div>
        );
    }

    public renderPublication = (publication: Publication) => (
        <PublicationItem
            key={publication.id}
            type="vertical"
            entity={publication}
        />
    );

    public renderResearcher = (researcher: Researcher) => (
        <ResearcherBlock
            key={researcher.id}
            entity={researcher}
        />
    );

    /* tslint:disable-next-line */
    public render() {
        const { data: { news, themes, researchers, publications } , isLoading, isDesktop } = this.props;

        if (isLoading) {
            return <HomePageStub />;
        }

        const blocks = [(
            <div className={blockClass_()} key="banner">
                <Banner {...bannerData} />
            </div>
        )];

        if (Boolean(news.length)) {
            blocks.push(
                <div className={blockClass_()} key="news">
                    {this.renderBlockHead('News', { url: '/news', text: 'All news' })}
                    <News
                        compact={!isDesktop}
                        items={news}
                    />
                </div>
            );
        }

        if (Boolean(themes.length)) {
            blocks.push(
                <div className={blockClass_()} key="themes">
                    {this.renderBlockHead('Research areas')}
                    <Themes items={themes} />
                </div>
            );
        }

        if (Boolean(publications.length)) {
            blocks.push(
                <EntitiesBlock
                    key="publications"
                    className="publications"
                    title="Latest publications"
                    linkToAllEntities={{ text: 'All publications', url: '/publications' }}
                    entities={publications}
                    renderItem={this.renderPublication}
                />
            );
        }

        if (Boolean(researchers.length)) {
            blocks.push(
                <ResearchersHomeBlock
                    key="researchers"
                    entities={researchers}
                    description={researchersDescription}
                />
            );
        }

        if (blocks.length === 1) {
            return blocks;
        }

        // Здесь мы формируем список блоков с разделителями.
        // Разделители нужны только после баннера и следующего за ним блока.
        const blocksWithSeparators = [
            blocks.shift(),
            blocks.shift()
        ];

        let i = 0;
        for (const block of blocks) {
            blocksWithSeparators.push(
                <hr key={`separator-${i++}`} className={blockClass_('separator')} />
            );
            blocksWithSeparators.push(block);
        }

        return (
            <div className={`centering ${class_()}`}>
                <PageMeta title={pageConfig.meta.title} description={pageConfig.meta.description} />

                {blocksWithSeparators}
            </div>
        );
    }
}
